import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const RedirectComponent = ({ componentRole }) => {
  const loginStatus = useSelector((state) => state.auth.loginStatus);
  const role = useSelector((state) => state.auth.role);
  const navigate = useNavigate();

  useEffect(() => {
    const normalizedRole = role?.toLowerCase?.();
    const normalizedComponentRole = componentRole?.toLowerCase?.();
    if (loginStatus !== 'SUCCESS' || normalizedRole !== normalizedComponentRole) {
      const redirectPath = loginStatus !== 'SUCCESS' ? '/login' : '/homepage';
      navigate(redirectPath);
    }
  }, [loginStatus, role, componentRole, navigate]);

  return null;
};

export default RedirectComponent;